module.exports = __webpack_public_path__ + "static/media/foto_3.1f4bb590.png";